export type SpaceId = 'support' | 'product' | 'systems';

export interface Space {
  id: SpaceId;
  roleId: string;
  label: string;
}

// Roles organise navigation and never authorise: each route stays gated by its permission.
// Order is the selector's and the landing's. TODO: i18n
export const SPACES: readonly Space[] = [
  { id: 'support', roleId: 'cc', label: 'Soporte' },
  { id: 'product', roleId: 'product', label: 'Producto' },
  { id: 'systems', roleId: 'systems', label: 'Sistemas' },
];
